<template>
    <div class="vl-region vl-region--arrow" :class="{ 'vl-region--alt': indicatief }">
        <div class="vl-layout">
            <h2 class="vl-title--h2">Aan de slag?</h2>
            <div class="vl-u-spacer--small">
                <div class="vl-grid vl-grid--is-stacked">
                    <div class="vl-col--4-12 vl-col--6-12--m vl-col--1-1--s">
                        <a href="https://www.vlaanderen.be/premies-voor-renovatie" target="_blank"
                           class="vl-news-teaser js-vl-equal-height vl-u-mobile-no-equal-height"
                           :class="{ 'bg-white': indicatief, 'bg-gray': !indicatief}">
                            <article role="presentation">
                                <div class="vl-news-teaser__image">
                                    <img src="@/assets/images/600energiepremies.jpg"
                                         itemprop="image" alt=""/>
                                </div>
                                <div class="vl-news-teaser__content">
                                    <p class="vl-news-teaser__label">PREMIES</p>
                                    <h3 class="vl-news-teaser__title" itemprop="name">
                                        De overheid ondersteunt u: zoek hier uw energiepremie!
                                    </h3>
                                </div>
                            </article>
                        </a>
                    </div>
                    <div class="vl-col--4-12 vl-col--6-12--m vl-col--1-1--s">
                        <a href="https://www.energiesparen.be/epcparticulier" target="_blank"
                           class="vl-news-teaser js-vl-equal-height vl-u-mobile-no-equal-height"
                           :class="{ 'bg-white': indicatief, 'bg-gray': !indicatief}">
                            <article role="presentation">
                                <div class="vl-news-teaser__image">
                                    <img src="@/assets/images/600topscore.gif"
                                         itemprop="image" alt=""/>
                                </div>
                                <div class="vl-news-teaser__content">
                                    <p class="vl-news-teaser__label">EPC</p>
                                    <h3 class="vl-news-teaser__title" itemprop="name">
                                        Benieuwd naar uw echte energielabel? Laat een EPC opmaken
                                    </h3>
                                </div>
                            </article>
                        </a>
                    </div>
                    <div class="vl-col--4-12 vl-col--6-12--m vl-col--1-1--s">
                        <a href="https://www.mijnenergiehuis.be/contacteer-mij" target="_blank"
                           class="vl-news-teaser js-vl-equal-height vl-u-mobile-no-equal-height"
                           :class="{ 'bg-white': indicatief, 'bg-gray': !indicatief}">
                            <article role="presentation">
                                <div class="vl-news-teaser__image">
                                    <img src="@/assets/images/600energie-dim.gif"
                                         itemprop="image" alt=""/>
                                </div>
                                <div class="vl-news-teaser__content">
                                    <p class="vl-news-teaser__label">ENERGIEHUIZEN</p>
                                    <h3 class="vl-news-teaser__title" itemprop="name">
                                      Gratis advies? Laat u contacteren door uw energiehuis
                                    </h3>
                                </div>
                            </article>
                        </a>
                    </div>
                </div>
            </div>
            <a href="https://www.vlaanderen.be/veka" target="_blank" class="vl-link">
                <i class="vl-link__icon vl-link__icon--before vl-vi vl-vi-arrow-right-fat"></i>
                Meer weten over energiezuinig bouwen en verbouwen?
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'beterScoren',
        props: ['indicatief'],
        data: function () {
            return {}
        }
    }
</script>
